// extracted by mini-css-extract-plugin
export default {"layout":"StandardLayout_layout__tkSbl","layout__main":"StandardLayout_layout__main__9DMF-"};